import { dashboardAPI } from "@/services";
import moment from "moment";

// Store the polling interval outside the actions to maintain state
let pollingInterval = null;

function startPolling(context) {
  // Clear any existing interval
  if (pollingInterval) {
    clearInterval(pollingInterval);
  }

  const pollInterval = process.env.NODE_ENV === "development" ? 60000 : 60000;
  pollingInterval = setInterval(() => {
    context.dispatch("updateDashboard", "Dashboard polling update");
  }, pollInterval);
}

function stopPolling() {
  if (pollingInterval) {
    clearInterval(pollingInterval);
    pollingInterval = null;
  }
}

function populateComponent(
  APICall,
  context,
  setStateData,
  setStateLoading,
  queryParamsContext
) {
  APICall(queryParamsContext)
    .then((response) => {
      context.commit(setStateData, response);
      context.commit(setStateLoading, false);
      console.log(setStateData, response);
    })
    .catch((err) => {
      console.log(`${setStateData.toUpperCase()} component API error`, err);
      // Attempt to refresh token if that was the error (this may not be the right place)
    });
}

export default {
  startDashboardPolling(context) {
    startPolling(context);
  },

  stopDashboardPolling() {
    stopPolling();
  },

  updateDashboard(context, event) {
    console.log("UPDATE DASHBOARD EVENT:", event);

    // Restart polling on every update
    startPolling(context);

    var selectedEvent = context.rootState.filter.globalEventFilter;
    var eventId = selectedEvent.EventId;

    // Check if this is a polling update and event is more than 7 days old
    if (event === "Dashboard polling update" && selectedEvent.endDateTime) {
      // Parse the date format YYYYMMDDHHmm using moment
      const eventEndDate = moment(
        selectedEvent.endDateTime,
        "YYYYMMDDHHmm"
      ).toDate();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

      if (eventEndDate < sevenDaysAgo) {
        console.log(
          "Event is more than 7 days old, stopping polling for updates"
        );
        stopPolling();
        return;
      }
    }

    var searchStartTime = context.rootState.filter.searchStartTime;
    var searchEndTime = context.rootState.filter.searchEndTime;
    var searchStallholders = context.rootState.filter.searchStallholders;
    var searchStalls = context.rootState.filter.searchStalls;

    // If no event id, set the start and end times to not set
    // This returns blank data to display
    if (!eventId) {
      searchEndTime = "notSet";
      searchStartTime = "notSet";
    }
    // If the search end time is the same as the event end time, set it to not set
    // As the query is faster
    if (searchEndTime === selectedEvent.endDateTime) {
      searchEndTime = "notSet";
    }
    if (searchStartTime === selectedEvent.startDateTime) {
      searchStartTime = "notSet";
    }

    // var allStalls = context.rootState.filter.allStalls

    // var stallHolderFilters = context.rootState.filter.filterStallHolders
    // var stallFilters = context.rootState.filter.filterStalls

    // CHANGE HERE:
    // var listOfStalls = context.rootState.filter.globalEventFilter.Stallholders.map(stallHolder => stallHolder.Stalls)
    // var stallFilters = listOfStalls.flat()
    // var stallHolderFilters = context.rootState.filter.globalEventFilter.Stallholders

    // Home page
    var homeAPI = dashboardAPI.getHomeAPI();
    var homeContext = {
      eventId: eventId,
      searchStartTime: searchStartTime,
      searchEndTime: searchEndTime,
    };
    populateComponent(
      homeAPI.getTotals.bind(homeAPI),
      context,
      "setHomeTotals",
      "setHomeTotalsLoading",
      homeContext
    );

    // Product Sales
    var productSalesAPI = dashboardAPI.getProductSalesAPI();
    var productSalesContext = {
      eventId: eventId,
      searchStartTime: searchStartTime,
      searchEndTime: searchEndTime,
      searchStallholders: searchStallholders,
      searchStalls: searchStalls,

      // stallholderStallFilter: stallFilters.length == allStalls.length && stallHolderFilters == 'all' ? 'all-all' : stallFilters.map(x => x.StallholderStall),

      // stalls: stallFilters.map(x => x.StallholderStall)
    };

    populateComponent(
      productSalesAPI.getTotalTransactions.bind(productSalesAPI),
      context,
      "setProductSalesTotalTransactions",
      "setProductSalesTotalTransactionsLoading",
      productSalesContext
    );

    // Takings
    var takingsAPI = dashboardAPI.getTakingsAPI();

    var takingsContext = {
      eventId: eventId,
      searchStartTime: searchStartTime,
      searchEndTime: searchEndTime,
      searchStallholders: searchStallholders,
      searchStalls: searchStalls,

      // If user selects all available stalls then it given that all stallholders are also selected
      // stallholderStallFilter: stallFilters.length == allStalls.length && stallHolderFilters == 'all' ? 'all-all' : stallFilters.map(x => x.StallholderStall),
      // stalls: stallFilters.map(x => x.StallholderStall)
    };
    populateComponent(
      takingsAPI.getTotalSales.bind(takingsAPI),
      context,
      "setTakingsTotalSales",
      "setTakingsTotalSalesLoading",
      takingsContext
    );

    // populateComponent(takingsAPI.getStallComparison.bind(takingsAPI),
    // context, 'setTakingsStallComparison', 'setTakingsStallComparisonLoading', takingsContext)
  },

  getTransactions(context) {
    dashboardAPI
      .getTransactionsAPI()
      .getTransactions("TESTING transactions")
      .then((response) => {
        context.commit("setTransactionsTransactions", response);
      });
  },

  getReports(context, payload) {
    const api = dashboardAPI.getReportsAPI();
    return api.getReports(payload).then((response) => {
      console.log("Starting actions.js getReports");
      return response;
    });
  },

  prepareReport(context, reportType) {
    var selectedEvent = context.rootState.filter.globalEventFilter;

    var searchStartTime = context.rootState.filter.searchStartTime;
    var searchEndTime = context.rootState.filter.searchEndTime;

    // If the search end time is the same as the event end time, set it to not set
    // As the query is faster
    if (searchEndTime === selectedEvent.endDateTime) {
      searchEndTime = "notSet";
    }
    if (searchStartTime === selectedEvent.startDateTime) {
      searchStartTime = "notSet";
    }

    const report = {
      reportType: reportType, //takingsReport
      requestItems: {
        stallholders: context.rootState.filter.searchStallholders,
        stalls: context.rootState.filter.searchStalls,
        eventId: context.rootState.filter.globalEventFilter.EventId,
      },
    };

    if (searchStartTime != "notSet") {
      report.requestItems.startTime = searchStartTime;
    }
    if (searchEndTime != "notSet") {
      report.requestItems.endTime = searchEndTime;
    }

    return report;
  },
};
